import { useQuery } from '@tanstack/react-query';
import { driverApi } from '../services/driverApi';
import { useHybridAuth } from './useHybridAuth';

/** One driver (GET /drivers/:id), for the mobile shell's driver screen. */
export const useDriver = (driverId: string | undefined) => {
  const { getAccessTokenSilently, isAuthenticated } = useHybridAuth();
  return useQuery({
    queryKey: ['driver', driverId],
    queryFn: async () => {
      driverApi.setAuthToken(await getAccessTokenSilently());
      return driverApi.getDriver(driverId!);
    },
    enabled: isAuthenticated && !!driverId,
  });
};
